import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Wrapper that only renders children when the current user has the
 * `isAdmin` custom claim. Non‑admins are redirected to the dashboard, and
 * unauthenticated visitors are sent to the login page.
 *
 * Usage:
 *   <AdminRoute><SomeComponent /></AdminRoute>
 * @param {{ children?: React.ReactNode }} props
 */
export default function AdminRoute({ children }) {
  const navigate = useNavigate();
  const { user, isAdmin, isAuthResolved } = useAuth();

  useEffect(() => {
    if (!isAuthResolved) return;
    if (!user) {
      navigate('/login', { replace: true });
      return;
    }
    if (!isAdmin) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthResolved, user, isAdmin, navigate]);

  if (!isAuthResolved) return null;
  return user && isAdmin ? children : null;
}
